
import { i18nText } from '@/locales';
import { VisitTypeAddRequestType } from 'src/form/visits/Pay/Visit.types';

export class VisitPayFormData {
    
    public visit_id: number | null;
    public membership_id: number | null;
    public certificate_id: number | null;
    public sum: number | null;
    public cashbox_id: number | null;
    public account_pay: boolean | null;
    public account_pay_partial: boolean | null;

    setFormData(data: VisitTypeAddRequestType): void {
    
        this.visit_id = data.visit_id;
        this.membership_id = data.membership_id;
        this.certificate_id = data.certificate_id;
        this.sum = data.sum;
        this.cashbox_id = data.cashbox_id;
        this.account_pay = data.account_pay;
        this.account_pay_partial = data.account_pay_partial
    }
    constructor() {
        this.visit_id = null;
        this.membership_id = null;
        this.sum = null;
        this.cashbox_id = null;
        this.certificate_id = null;
        this.account_pay = null;
        this.account_pay_partial = null
    }

}
export const formRules = {
    sum: [{ required: true, message: i18nText("Укажите сумму платежа"), trigger: 'change' }],
    cashbox_id: [{ required: true, message: i18nText("Укажите кассу"), trigger: 'change' }],
};
